import {
  GET_UNAVAILABLE_WINDOWS,
} from './actionTypes';
import { newNotification } from './uiActions';
import { logToDatadog } from '../services/datadog';
import { orderfulApi } from '../services/api-instances';

export const getAllUnavailableWindows = (cellId: number, startDate?: string, endDate?: string) => async dispatch => {
  try {
    const unavailableWindows = await orderfulApi.getAllUnavailabileWindowsForCell(cellId, startDate, endDate);
    const startDateMs = new Date(startDate).getTime();
    const endDateMS = new Date(endDate).getTime();
    const filteredWindows = unavailableWindows.filter(unavailableWindow => {
      const windowStartDateMs = new Date(unavailableWindow.startDate).getTime();
      const windowEndDateMs = new Date(unavailableWindow.endDate).getTime();
      return startDateMs < windowEndDateMs && windowStartDateMs < endDateMS;
    });
    dispatch({
      type: GET_UNAVAILABLE_WINDOWS,
      payload: filteredWindows
    });

  } catch (error) {
    logToDatadog('Error getting unavailable windows', {error})
    dispatch(
      newNotification({
        variant: 'error',
        message: "Error getting unavailable windows"
      })
    );

  };
};
